import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import FAQItemsBlockData from 'app/Models/Content/FAQItemsBlockData';
import FAQItemBlockData from 'app/Models/Content/FAQItemBlockData';
import React, {useContext, useEffect, useState} from 'react';
import FAQItemBlock from './FAQItemBlock';
import useFadeIn from 'app/Components/Shared/UseFadeIn';
import MarketingTextBlockData from 'app/Models/Content/MarketingTextBlockData';
import {getTextWithHighlight} from 'app/utilities/highlightText';
import Config from 'app/Config';
import BusinessInvoicesContext from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import TheCounterContext, {categoryFilterFunc} from 'app/Components/Page/TheCounterPage/TheCounterContext';
import {isMobile} from 'react-device-detect';
import './FAQItemsBlock.scss';

const FAQItemBlockAny: any = FAQItemBlock;

const FAQItemsBlock = ({data, context}: ComponentProps<FAQItemsBlockData>) => {
  const {fadeClass, ref} = useFadeIn();
  const buisnessContext = useContext(BusinessInvoicesContext);
  const [selectedCategory] = useContext(TheCounterContext) ?? [null];
  const [items, setItems] = useState<FAQItemBlockData[]>(null);
  const [showAllItems, setShowAllItems] = useState(false);

  const title = data.title.expandedValue ? (data.title.expandedValue[0] as MarketingTextBlockData) : null;
  const isBuisness = buisnessContext != null;
  const numberOfItemsToDisplay = Number(data.numberOfItemsToDisplay?.value);
  const hasItemsLimit = Number.isFinite(numberOfItemsToDisplay) && numberOfItemsToDisplay > 0;
  const visibleItems = hasItemsLimit && !showAllItems ? items?.slice(0, numberOfItemsToDisplay) : items;

  const telOnClick = () => buisnessContext && buisnessContext[1]({type: 'faq', status: 'button'});
  const itemOnOpen = () => buisnessContext && buisnessContext[1]({type: 'faq', status: 'item'});

  useEffect(() => {
    if (!data.operationBoxItems?.expandedValue) return setItems(null);
    const items = (data.operationBoxItems.expandedValue as FAQItemBlockData[]).filter((item) => categoryFilterFunc(item, selectedCategory));
    setItems(items);
    setShowAllItems(false);
  }, [data.operationBoxItems, selectedCategory]);

  return (
    <div className='FAQItemsBlock'>
      <div ref={ref} className={isBuisness ? null : fadeClass}>
          {title != null && (
            <div className='FAQItemsBlock__title'>
              {getTextWithHighlight({
                text: title.text.value || 'שאלות',
                highlightText: title.highlightText.value,
              })}
            </div>
          )}
          <div className='FAQItemsBlock__items'>
            {visibleItems?.map((item, i) => (
              <div key={i}>
                {i > 0 && <div className='FAQItemsBlock__separator' />}
                {React.createElement(FAQItemBlockAny, {data: item, isBuisness, onOpen: itemOnOpen})}
              </div>
            ))}
          </div>
          {hasItemsLimit && !showAllItems && items?.length > numberOfItemsToDisplay && (
            <div className='FAQItemsBlock__show-more-wrapper'>
              <button type='button' className='FAQItemsBlock__show-more-button' onClick={() => setShowAllItems(true)}>
                עוד שאלות
                <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10' fill='none'>
                  <path d='M5 0C5.55228 -7.11888e-10 6 0.447715 6 1V4H9C9.55229 4 10 4.44772 10 5C10 5.55228 9.55229 6 9 6H6V9C6 9.55229 5.55228 10 5 10C4.44772 10 4 9.55229 4 9V6H1C0.447715 6 4.71177e-07 5.55228 0 5C6.03529e-08 4.44772 0.447715 4 1 4H4V1C4 0.447715 4.44772 3.31941e-08 5 0Z' fill='var(--Marketing-Primary, #810EA9)'/>
                </svg>
              </button>
            </div>
          )}
          {isBuisness && (
            <div className='FAQItemsBlock__contact'>
              <div className='FAQItemsBlock__contact__title'>עדיין נתקל בבעיה?</div>
              {isMobile && (
                <>
                  <a className='FAQItemsBlock__contact__link' href={`tel:${Config.businessCallNumber}`} onClick={telOnClick}>
                    <Image src={require('./images/contact-call-phone.svg')} />
                  </a>
                  <div className='FAQItemsBlock__contact__comment'>דברו איתנו</div>
                </>
              )}
              {!isMobile && (
                <>
                  <div className='FAQItemsBlock__contact__link'>
                    <Image src={require('./images/contact-call-phone.svg')} />
                  </div>
                  <div className='FAQItemsBlock__contact__comment'>
                    דברו איתנו ב- <b dir='ltr'>{Config.businessCallNumber}</b>
                  </div>
                </>
              )}
            </div>
          )}
      </div>
    </div>
  );
};

export default FAQItemsBlock;
